module.exports = __webpack_public_path__ + "static/media/function.10fa401a.svg";